import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Grid,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { ROUTES } from "constants/routes";
import { Link, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import SearchListCardItem from "./search-list-card-item";
import { clearSearchFilters } from "slices/searchListingReducer";

const ListingCards = ({ isMapView }: { isMapView: Boolean }) => {
  const { searchListingReducer }: any = useAppSelector((state) => state);
  const { list, loading } = searchListingReducer;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return (
    <Box sx={{ px: "4%" }}>
      {loading && (
        <Grid container spacing="2%">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(() => (
            <Grid
              item
              xs={6}
              sm={6}
              md={isMapView ? 4 : 3}
              lg={isMapView ? 4 : 3}
              xl={isMapView ? 4 : 3}
            >
              <Skeleton
                variant="rectangular"
                sx={{
                  height: {
                    md: "256px",
                    lg: "256px",
                    xl: "256px",
                    sm: "130px",
                    xs: "130px",
                  },
                  borderRadius: "10px",
                }}
              />
            </Grid>
          ))}
        </Grid>
      )}
      {!loading && (
        <Grid container spacing="2%">
          {list?.length ? (
            list?.map((d: any) => (
              <Grid
                item
                xs={6}
                sm={6}
                md={isMapView ? 4 : 3}
                lg={isMapView ? 4 : 3}
                xl={isMapView ? 4 : 3}
                key={d.listing_name + d.id}
              >
                <SearchListCardItem {...d} />
              </Grid>
            ))
          ) : (
            <Box
              sx={{
                mx: "4%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                width: "100%",
                my: "8%",
              }}
            >
              <Box
                component="img"
                src="/assets/img/icons/search_blank.svg"
                alt=""
                sx={{
                  width: {
                    md: "393px",
                    lg: "393px",
                    xl: "393px",
                    sm: "250px",
                    xs: "250px",
                  },
                }}
              />
              <Typography
                sx={{
                  color: "#323232",
                  fontWeight: 700,
                  fontSize: "26px",
                  lineHeight: "31px",
                  mt: "20px",
                  mb: "10px",
                  textAlign: "center",
                }}
              >
                No Tractor and Equipment Found!
              </Typography>
              <Typography
                sx={{
                  color: "#A2A2A2",
                  fontWeight: 500,
                  fontSize: "16px",
                  lineHeight: "24px",
                  mb: "15px",
                  textAlign: "center",
                }}
              >
                No equipment found as per your search, Please change the filter
                to find your best match.
              </Typography>

              <Button
                variant="contained"
                sx={{
                  borderRadius: "10px",
                  height: "56px",
                  mt: "15px",
                  width: "200px",
                }}
                onClick={() => {
                  dispatch(clearSearchFilters());
                  navigate("/search-listing");
                }}
              >
                Search Again
              </Button>
            </Box>
          )}
        </Grid>
      )}
    </Box>
  );
};

export default ListingCards;
